export default {
  PREFERRED_LANES: '/carrier/lanes',

  READ_PREFERRED_LANES: '/read',
  ADD_PREFERRED_LANE: '/add',
  UPDATE_PREFERRED_LANE: '/update',
  DELETE_PREFERRED_LANE: (laneId) => `/delete?lane_id=${laneId}`
}
